"use client";

import dynamic from "next/dynamic";

const CookieBanner = dynamic(
  () =>
    import("@/components/analytics/cookie-banner").then((module) => ({
      default: module.CookieBanner,
    })),
  { ssr: false },
);

/** One consent prompt/preferences control for every route group. */
export function GlobalCookieControl() {
  return <CookieBanner />;
}
